import { createAction, createReducer } from "redux-act";
import produce from "immer";

import { reducerRegistry } from "../reducerRegistry";

export type LayersState = {
  ts: Record<string, number>;
  layerInfosLoading: boolean;
  layerInfosError: Error;
};

export const reducerName = "layers";

const initialState: LayersState = {
  ts: {},
  layerInfosLoading: false,
  layerInfosError: null,
};

export const setLayersTs = createAction<LayersState["ts"]>("layers/setLayersTs");
export const setLayerInfosLoading = createAction<LayersState["layerInfosLoading"]>("layers/setLayerInfosLoading");
export const setLayerInfosError = createAction<LayersState["layerInfosError"]>("layers/setLayerInfosError");
export const reducer = createReducer({}, initialState);

reducer.on(
  setLayersTs,
  produce((layersState: LayersState, payload: LayersState["ts"]) => {
    layersState.ts = payload;
  }),
);

reducer.on(
  setLayerInfosLoading,
  produce((layersState: LayersState, payload: LayersState["layerInfosLoading"]) => {
    layersState.layerInfosLoading = payload;
  }),
);

reducer.on(
  setLayerInfosError,
  produce((layersState: LayersState, payload: LayersState["layerInfosError"]) => {
    layersState.layerInfosError = payload;
  }),
);

reducerRegistry.register(reducerName, reducer);
